// Insiders' brokerage registration, exactly as developers need it when an agent registers a
// booking under Insiders. Same values as the UAE agreement and the lifecycle emails.
export const INSIDERS_COMPANY = {
  legalName: 'INSIDERS PLATFORM REAL ESTATE L.L.C',
  licenceNo: '1639547',
  reraOrn: '63494',
} as const;
